import { useState, useEffect } from 'react'
import MeetingRoomService from 'service/MeetingRoomService'

export default function useGetMeetingLocationList() {
  const [data, updateData] = useState<any[]>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  function fetchData() {
    setIsLoading(true)
    MeetingRoomService.getMeetingRoomLocations()
      .then((r) => updateData(r.data))
      .catch((err) => setError(true))
      .finally(() => setIsLoading(false))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchData(), [])

  return { data, isLoading, error }
}
